// default imports for react project
import React from "react";

// import default style component from react-bootstrap package
import { Col, Container, Row } from "react-bootstrap";

// Import image from assets folder
import { main } from "assets/images/images";

//   import custom component
import BodyButton from "../../components/Buttons/BodyButton";
import Card1 from "../../components/Card/Card1";

// import util to get current window dimensions
import useWindowDimensions from "../../utils/useWindowDimension";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router";
import { useHistory } from "react-router";
import { clearState } from "store/actions/products";
import { useEffect } from "react";
import Brochure from '../../assets/images/brochure.pdf'
import { setParam } from "utils/utils";

// React functional component starts here..
function Homepage() {
  // scroll window to top of page on navigation
  window.scrollTo(0, 0);

  // Get width from util
  const { width } = useWindowDimensions();

  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();
  const currentToken = useSelector((state) => state.auth.currentUserToken);
 
  function parseQuery(queryString) {
    var query = {};
    var pairs = (queryString[0] === '?' ? queryString.substr(1) : queryString).split('&');
    for (var i = 0; i < pairs.length; i++) {
        var pair = pairs[i].split('=');
        query[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1] || '');
    }
    return query;
  }


  useEffect(() => {
    dispatch(
      clearState()
    )
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location])

  // useEffect(() => {
  //   setParam(history,parseQuery(location.search).token)
  // },[])

 useEffect(() => {
   dispatch({
     type: "CURRENT_USER_TOKEN",
     payload: parseQuery(location.search).token ?? currentToken,
   });
 }, []);

 useEffect(() => {
   setParam(history, currentToken);
 }, [currentToken]);

  return (
    <div style={{width: '100%', maxWidth: '100%', overflowX: 'hidden'}}>
      <div className=" background-primary homepage-banner-pattern m-0">
        <Container>
          <Row className="py-3" >
            <Col lg={5} xs={12} className="d-flex position-relative justify-content-center align-items-center">
              {width > 500 && <img src={main} className="main__img" alt="main" />}
            </Col>
            <Col lg={7} xs={12} className="homepage__main__text zIndex-100">
              <Row className="homepage1__heading1 app__header__one m-0 mb-2">
                SA’s first and only all-in-one, all-risk third-party legal liability policy for small businesses. All the cover you need, all wrapped up in one.
              </Row>
              <Row className="m-0 homepage-button-container">
                <Col lg={12} md={6} className={`p-0 d-flex ${width > 770 ? 'flex-row' : 'flex-column'} justify-content-start text-left`}>
                  <Row className={`justify-content-center ${width > 770 ? 'flex-row' : 'flex-column'}`}>
                  <Col>
                    <BodyButton
                        color="white"
                        bg="rgb(55, 63, 77)"
                        name="See Cover Details"
                        size={16}
                       
                        marginT={width > 770 ? 20 : 20}
                        weight={700}
                        height="auto"
                        width={width > 770 ? 215 : '100%'}
                        align={width > 770 ? "left" : "center"}
                        link="/fast-facts"
                        id="landing-page-cover-details-button"
                      />
                  </Col>
                  <Col>
                  <a href={Brochure} rel="noreferrer" style={{ textDecoration: 'none' }} target="_blank">
                    <BodyButton
                      color="white"
                      bg="#5B727A"
                      name="Download our Brochure"
                      size={16}
                    
                      marginT={width > 770 ? 20 : 20}
                      weight={700}
                     
                      width={width > 770 ? 215 : '100%'}
                      align={width > 770 ? "left" : "center"}
                      id="landing-page-brochure-button"

                    />
                  </a></Col>
                  <Col>
                  <a href={'/sureThing-video'} rel="noreferrer" style={{ textDecoration: 'none' }} target="_blank">
                    <BodyButton
                       color="white"
                       bg="rgb(55, 63, 77)"
                       name="Watch Video"
                       size={16}
                       marginL={0}
                       marginT={width > 770 ? 20 : 20}
                       weight={700}
                       width={width > 770 ? 215 : '100%'}
                       align={width > 770 ? "left" : "center"}
                       id="landing-page-video-button"
                    />
                  </a>
                  </Col>
                  </Row>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </div>
     {width > 770 && <div className="background-secondary">
        <Container>
          <Row className="pt-4 pb-5">
            <div className="app__header__two text-white">
              For a small business owner, legal surprises are never good news.
            </div>
            <div className="text-white">
              As South Africa's first and only all-in-one, all-risk legal liability policy for small businesses, you no longer need to roll the dice by cherry picking
              individual policies. SureThing provides all the cover you need, grouped together at an affortable rate.
            </div>
          </Row>
        </Container>
      </div>}
      <Container>
        <Row className="mt-5">
          <Card1 width={width} />
        </Row>
      </Container>
    </div>
  );
}

export default Homepage;
